<template>
  <a-layout-header :style="{ position: 'fixed', zIndex: 1, width: '100%' }">
    <div class="logo">
      <router-link to="/home"
        ><img
          v-if="hostName.indexOf('diamond-up.com') != -1"
          src="@/assets/img/logo_du.png"
          alt="" /><img class="logo2" v-else src="@/assets/img/logo.png" alt=""
      /></router-link>
    </div>

    <div class="funcRight">
      <!-- <i class="iconfont tlicon-help" />
      <i class="iconfont tlicon-settings" />
      <i class="iconfont tlicon-Style" /> -->
        <div style="color:white;">{{currentTimeZoneName}}</div>
      <a-popover v-if="isCoa">
        <template slot="content">
          <a-row
            type="flex"
            justify="space-between"
            style="flex-direction: column"
          >
            <a-button
              v-for="zone in timeZones"
              :key="zone.name"
              type="link"
              style="text-align: left"
              :disabled="currentTimeZone == zone.diff"
              @click="changeTimeZone(zone.diff)"
              >{{ zone.name }} {{ " (UTC " + zone.gmt + " )" }}</a-button
            >
          </a-row>
        </template>
        <i class="iconfont tlicon-time-zone" />
      </a-popover>

      <a-divider v-if="isCoa" type="vertical" />
      <a-popover>
        <template slot="content">
          <a-button type="link" @click="changeLocale('en')">English</a-button
          ><br />
          <a-button type="link" @click="changeLocale('zh-cn')"
            >简体中文</a-button
          >
        </template>
        <i class="iconfont tlicon-global" />
      </a-popover>

      <a-divider type="vertical" />
      <a-popover>
        <template slot="content">
          <a-button type="link" @click="changePassword">Change Password</a-button
          ><br />
          <a-button type="link" @click="doLogout"
            >Logout</a-button
          >
        </template>
       <i class="iconfont tlicon-logout" />
      </a-popover>
      
    </div>

    <!-- 修改密码弹窗 -->
    <a-modal
      v-model="passwordModalVisible"
      title="Change Password"
      :confirmLoading="passwordSubmitting"
      @ok="handlePasswordSubmit"
      @cancel="handlePasswordCancel"
    >
      <a-form-model
        ref="passwordForm"
        :model="passwordForm"
        :rules="passwordRules"
        :label-col="{ span: 8 }"
        :wrapper-col="{ span: 14 }"
      >
        <a-form-model-item label="Old Password" prop="oldPassword">
          <a-input-password v-model="passwordForm.oldPassword" placeholder="Enter old password" />
        </a-form-model-item>
        <a-form-model-item label="New Password" prop="newPassword">
          <a-input-password v-model="passwordForm.newPassword" placeholder="Enter new password" />
        </a-form-model-item>
        <a-form-model-item label="Confirm Password" prop="confirmPassword">
          <a-input-password v-model="passwordForm.confirmPassword" placeholder="Confirm new password" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <a-menu
      theme="dark"
      mode="horizontal"
      :selectable="false"
      @click="onClickMenu"
    >
      <a-menu-item v-for="item in menuList" :key="item.id">
        {{ $t(`menu.${item.code}`) }}
      </a-menu-item>
    </a-menu>
  </a-layout-header>
</template>
<script>
import { mapActions } from "vuex";
import mainServer from "@/api/index";
export default {
  data() {
    const validateConfirmPassword = (rule, value, callback) => {
      if (value !== this.passwordForm.newPassword) {
        callback(new Error("Passwords do not match"));
      } else {
        callback();
      }
    };
    return {
      isCoa: location.href.indexOf("coa") != -1,
      passwordModalVisible: false,
      passwordSubmitting: false,
      passwordForm: {
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
      },
      passwordRules: {
        oldPassword: [{ required: true, message: "Please enter old password", trigger: "blur" }],
        newPassword: [
          { required: true, message: "Please enter new password", trigger: "blur" },
          { min: 6, message: "Password must be at least 6 characters", trigger: "blur" },
        ],
        confirmPassword: [
          { required: true, message: "Please confirm new password", trigger: "blur" },
          { validator: validateConfirmPassword, trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    timeZones() {
      return this.$store.state.customer.timeZones;
    },
    currentTimeZone() {
      let tz = localStorage.getItem("timezone")
        ? localStorage.getItem("timezone")
        : "8";
      // console.log(tz)
      return tz;
    },
currentTimeZoneName(){
  let tz = this.timeZones.find(t=>t.diff == this.currentTimeZone);
  if(tz){
    return tz.name;
  }else {
    return ''
  }
},
    menuList() {
      let fullMenuList = this.$store.state.system.loginMenuList;
      let permissions = localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user")).permissions
        : [];
      return fullMenuList.filter(
        (item) => permissions.indexOf(item.permission) >= 0
      );
    },
    hostName() {
      return location.hostname.toLowerCase();
    },
  },
  watch: {
    "$route.path": function (newVal, oldVal) {
      this.isCoa = newVal.indexOf("coa") != -1;
    },
  },
  created() {
    this.loadTimeZones();
    this.loadCompanyInfo().then(() => {
      this.loadProducts();
      this.loadCountrys();
      this.loadSalesInfo();
      this.loadCustomerInfo();
      this.loadCustomerServiceInfo();
    });
  },
  methods: {
    ...mapActions([
      "loadCustomerInfo",
      "loadProducts",
      "loadCountrys",
      "loadSalesInfo",
      "loadCompanyInfo",
      "loadCustomerServiceInfo",
      "loadTimeZones",
    ]),
    onClickMenu(item) {
      if (item.key == 1) {
        this.$router.push("/booking");
      } else if (item.key == 2) {
        this.$router.push("/order");
      } else if (item.key == 3) {
        this.$router.push("/bill");
      } else if (item.key == 5) {
        this.$router.push("/customs");
      } else if (item.key == 6) {
        this.$router.push("/dashboard");
      } else if (item.key == 7) {
        this.$router.push("/mawb");
      } else if (item.key == 8) {
        this.$router.push("/trust");
      } else if (item.key == 9) {
        this.$router.push("/label");
      } else if (item.key == 10) {
        this.$router.push("/mawbOpt");
      } else if (item.key == 11) {
        this.$router.push("/databoard");
      } else if (item.key == 12) {
        this.$router.push("/coa");
      } else if (item.key == 13) {
        this.$router.push("/hts");
      } else if (item.key == 14) {
        this.$router.push("/tariff");
      } else if (item.key == 15) {
        this.$router.push("/mid");
      }  else {
        this.$router.push("/my");
      }
    },
    doLogout() {
      mainServer
        .logout({})
        .then(() => {
          localStorage.removeItem("ms_username");
          localStorage.removeItem("access_token");
          localStorage.removeItem("user");
          this.$router.push("/");
        })
        .catch(() => {
          localStorage.removeItem("ms_username");
          localStorage.removeItem("access_token");
          localStorage.removeItem("user");
          this.$router.push("/");
        });
    },
    changePassword(){
      this.passwordModalVisible = true;
      this.$nextTick(() => {
        this.$refs.passwordForm && this.$refs.passwordForm.clearValidate();
      });
      this.passwordForm = {
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
      };
    },
    handlePasswordSubmit() {
      this.$refs.passwordForm.validate((valid) => {
        if (!valid) return;
        this.passwordSubmitting = true;
        mainServer
          .changePassword({
            originpwd: this.passwordForm.oldPassword,
            newpwd: this.passwordForm.newPassword,
            confirmpwd: this.passwordForm.confirmPassword,
            userId: JSON.parse(localStorage.getItem("user")).userId,
          })
          .then(() => {
            this.$message.success("Password changed successfully, please login again");
            this.passwordModalVisible = false;
            localStorage.removeItem("ms_username");
            localStorage.removeItem("access_token");
            localStorage.removeItem("user");
            this.$router.push("/");
          })
          .catch(() => {
            this.$message.error("Failed to change password");
          })
          .finally(() => {
            this.passwordSubmitting = false;
          });
      });
    },
    handlePasswordCancel() {
      this.passwordModalVisible = false;
    },
    changeLocale(language) {
      this.$i18n.locale = language;
      this.$store.commit("setLanguage", language);
      localStorage.setItem("locale", language);
      location.reload();
    },
    changeTimeZone(zone) {
      this.$store.commit("setTimeZone", zone);
      localStorage.setItem("timezone", zone);
      location.reload();
    },
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
.logo {
  width: 120px;
  height: 31px;

  float: left;
  margin-right: 40px;

  img {
    width: 120px;
    height: 30px;
  }

  .logo2 {
    width: 120px;
    height: 22px;
  }
}

.funcRight {
  float: right;
  display: flex;
  align-items: center;
  height: 64px;
  /deep/ .ant-btn-link {
    color: #ffffff;
    opacity: 0.65;
  }
  /deep/ .ant-btn-link:hover {
    opacity: 1;
  }
  /deep/ .ant-divider-vertical {
    height: 20px;
    opacity: 0.65;
  }
  .iconfont::before {
    font-size: 18px;
    color: white;
    margin: 0 10px;
    cursor: pointer;
    opacity: 0.65;
  }
  .iconfont:hover {
    opacity: 1;
  }
}

/deep/ .ant-menu {
  text-align: left;
  font-size: 16px;
  .ant-menu-item {
    line-height: 64px;
    padding: 0 30px;
  }
}

.popContent {
  width: 830px;
  opacity: 0.95;
  padding: 50px 80px;

  .iconfont {
    font-size: 30px;
    color: #7fd8c0;
  }

  /deep/ .ant-collapse {
    border: none;

    .ant-collapse-item {
      border: none;
      background: white;
      .ant-collapse-header {
        border-bottom: 4px solid #e6e6e6;
        background-color: white;
        width: 200px;
        span {
          font-size: 24px;
          font-weight: 400;
          color: #333333;
          line-height: 24px;
          margin-left: 35px;
        }
      }
      .ant-collapse-content {
        border: none;
      }
      .ant-collapse-content-box {
        .item {
          font-size: 24px;
          font-weight: 400;
          color: #333333;
          line-height: 24px;
          margin: 30px 40px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/LoginHeader.vue